import ".././styles/styles.css";
import ".././styles/AdvertiseBanner.css";
import React, { useState, useEffect } from "react";

function AdvertiseBanner() {
  const [index, setIndex] = useState(0);
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetch("/api/ads");
        const data = await res.json();
        const list = Array.isArray(data.ads) ? data.ads : [];
        setAds(list);
        setIndex(0);
      } catch (err) {
        setError(err);
        setAds([]);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    let slider;
    if (ads.length > 0) {
      slider = setInterval(() => {
        setIndex((prev) => prev + 1);
      }, 7000);
    }
    return () => slider && clearInterval(slider);
  }, [ads]);

  useEffect(() => {
    if (ads.length > 0) {
      if (index > ads.length - 1) setIndex(0);
      if (index < 0) setIndex(ads.length - 1);
    }
  }, [index, ads]);

  if (loading) {
    return (
      <section id="promo-banner" style={{ minHeight: "220px", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <p>Loading promotions...</p>
      </section>
    );
  }

  if (error) {
    return (
      <section id="promo-banner" style={{ minHeight: "220px", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <p>Error loading promotions: {error.message}</p>
      </section>
    );
  }

  if (!ads.length) {
    return (
      <section id="promo-banner" style={{ minHeight: "220px", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <p>No promotions available.</p>
      </section>
    );
  }

  return (
    <section id="promo-banner">
      {ads.map((ad, adIndex) => {
        const { id, image, title, description, link } = ad;
        let position = "nextSlide";
        if (adIndex === index) position = "activeSlide";
        if (adIndex === index - 1 || (index === 0 && adIndex === ads.length - 1)) position = "lastSlide";

        return (
          <article key={id} className={position}>
            <div id="promo-details">
              <div>
                <h2 id="promo-title">{title}</h2>
                <p id="promo-description">{description}</p>
              </div>
            </div>
            <div id="promo-img-container">
              <a href={link} target="_blank" rel="noopener noreferrer">
                <img id="promo-pic" src={image} alt={title} />
              </a>
            </div>
          </article>
        );
      })}
    </section>
  );
}

export default AdvertiseBanner;
